import { BaseHTMLAttributes } from 'react';
import styled from 'styled-components';
const colors = require('common/lib/colors/colors.less');
import { makeRGBA } from 'common/lib/colors';

export interface BoardProps extends BaseHTMLAttributes<HTMLDivElement> {
  bgColor?: string;
  bgImage?: string | null;
  headerBgColor?: string | null;
  borderColor?: string;
  widthPx?: number;
}

export const Board = styled<BoardProps, 'div'>('div')`
  background-color: ${({ bgColor }) => {
    if (bgColor) {
      if (colors.hasOwnProperty(bgColor)) {
        return colors[bgColor];
      }

      return bgColor;
    } else {
      return colors['trello-blue-500'];
    }
  }};
  background-image: ${({ bgImage, headerBgColor }) => {
    if (!bgImage) {
      return 'none';
    }
    if (!headerBgColor) {
      return `url(${bgImage})`;
    }

    let headerColor;

    if (colors.hasOwnProperty(headerBgColor)) {
      headerColor = colors[headerBgColor];
    }

    headerColor = makeRGBA(headerBgColor, 0.7);

    const headerBg = `linear-gradient(0deg, ${headerColor} 50%, ${headerColor} 0%)`;

    return `${headerBg}, url(${bgImage})`;
  }};

  background-repeat: no-repeat;
  border: ${({ borderColor }) =>
    borderColor ? `1px solid ${colors[borderColor]}` : 'none'};
  border-radius: 3px;
  box-sizing: border-box;
  overflow: hidden;
  width: ${({ widthPx = 248 }) => widthPx}px;
`;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/shared/Board.tsx